(function(){
  "use strict";
  var DD_LOADMORE_COPY={"tr":{"products":"Ürünler yükleniyor…","plain":"Yükleniyor..."},"en":{"products":"Loading products…","plain":"Loading..."},"es":{"products":"Cargando productos…","plain":"Cargando..."},"ru":{"products":"Товары загружаются…","plain":"Загрузка..."},"ar":{"products":"جارٍ تحميل المنتجات…","plain":"جارٍ التحميل..."},"de":{"products":"Produkte werden geladen…","plain":"Wird geladen..."},"fr":{"products":"Chargement des produits…","plain":"Chargement..."}};
  function ddLoadmoreCopy(){return DD_LOADMORE_COPY[String(document.documentElement.lang||"tr").toLowerCase().split("-")[0]]||DD_LOADMORE_COPY.tr;}
  if(window.__DD_PRODUCT_LOADMORE_V1)return;
  window.__DD_PRODUCT_LOADMORE_V1=true;

  function escAttr(v){return String(v||"").replace(/\\/g,"\\\\").replace(/"/g,'\\"')}
  function emit(root,count){
    try{
      document.dispatchEvent(new CustomEvent("dd:products:appended",{bubbles:true,detail:{root:root,count:count}}));
    }catch(e){}
  }
  document.addEventListener("click",function(event){
    var button=event.target.closest&&event.target.closest("[data-dd-product-loadmore]");
    if(!button||button.disabled)return;
    var scope=button.closest("[data-dd-loadmore-scope]");
    if(!scope)return;
    var url=button.getAttribute("data-url");
    var key=scope.getAttribute("data-dd-loadmore-scope");
    if(!url||!key)return;

    event.preventDefault();
    button.disabled=true;
    button.setAttribute("aria-busy","true");
    var original=button.textContent;
    button.textContent=ddLoadmoreCopy().products;

    fetch(url,{credentials:"same-origin",headers:{"X-Requested-With":"XMLHttpRequest"}})
      .then(function(response){
        if(!response.ok)throw new Error("request");
        return response.text();
      })
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,"text/html");
        var incoming=doc.querySelector('[data-dd-loadmore-scope="'+escAttr(key)+'"]');
        var grid=scope.querySelector("[data-dd-loadmore-grid]");
        var incomingGrid=incoming&&incoming.querySelector("[data-dd-loadmore-grid]");
        if(!incoming||!grid||!incomingGrid)throw new Error("grid");

        var items=Array.prototype.slice.call(incomingGrid.querySelectorAll("[data-dd-loadmore-item]"));
        items.forEach(function(node){
          grid.appendChild(document.importNode(node,true));
        });

        var next=incoming.querySelector("[data-dd-product-loadmore]");
        var wrap=button.closest("[data-dd-product-loadmore-wrap]");
        if(next&&next.getAttribute("data-url")){
          button.setAttribute("data-url",next.getAttribute("data-url"));
          button.disabled=false;
          button.removeAttribute("aria-busy");
          button.textContent=original;
        }else if(wrap){
          wrap.remove();
        }else{
          button.remove();
        }
        emit(scope,items.length);
      })
      .catch(function(){
        button.disabled=false;
        button.removeAttribute("aria-busy");
        button.textContent=original;
        window.location.href=url;
      });
  });
})();